import {store} from '../redux/store';
import {getConfig} from "../context/configContext";

const parseTranslation = (translation) => {
  const config = getConfig();
  if (!config) return translation;

  return String(translation).replace(/##(.+?)##/g, (full, key) => {
    const value = config[key];
    return value == null ? full : String(value);
  });
};

const translate = (area, key) => {
    const state = store.getState();
    const config = getConfig();
    if (!config) {
        return area + ' - ' + key; // Fallback in case config is unavailable
    }

    let translations = state.settings.translations;
    try {
        let translation = translations[`${config.namespace}${area.length > 0 ? '/' + area : ''}`].find(item => item.hash === key).text;
        return parseTranslation(translation);
    } catch (error) {
        return area + ' - ' + key;
    }
}
export default translate;
